import { fromEvent, Observable, of, merge } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import { inject, InjectionToken, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { WINDOW } from '../window/window.token';

export const RESIZE_OBSERVER = new InjectionToken<Observable<Event | null>>('combine events resize and orientationchange', {
  providedIn: 'root',
  factory: () => {
    const window = inject(WINDOW);
    const platformId = inject(PLATFORM_ID);

    if (!isPlatformBrowser(platformId)) {
      return of(null);
    }

    return merge(fromEvent(window, 'resize'), fromEvent(window, 'orientationchange')).pipe(debounceTime(100));
  },
});
